import React from 'react';

interface LogoProps {
    width?: number;
    height?: number;
    idSuffix?: string;
}

export const Logo: React.FC<LogoProps> = ({ width = 32, height = 32, idSuffix = '' }) => (
    <svg width={width} height={height} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Codepipeline Logo">
        <title id={`logoTitle${idSuffix}`}>Codepipeline Logo</title>
        <defs>
            <linearGradient id={`logoGradient${idSuffix}`} x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#3315e8' }} />
                <stop offset="100%" style={{ stopColor: '#3d68ff' }} />
            </linearGradient>
        </defs>
        <rect x="4" y="4" width="32" height="32" rx="15" ry="15" fill={`url(#logoGradient${idSuffix})`} />
        <rect x="12" y="12" width="16" height="16" rx="6" ry="6" fill="#FFFFFF" />
    </svg>
);

export const CheckIcon: React.FC = () => (
    <svg className="w-4 h-4 text-[#3d68ff] mr-2 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" role="img" aria-label="Checkmark Icon">
        <title>Checkmark Icon</title>
        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
    </svg>
);
